export enum RoomStatusEnum {
  /** Rented */
  RENTED = 'RENTED',
  /** Free */
  FREE = 'FREE',
  /** Reserve */
  RESERVE = 'RESERVE',
  /** On repair */
  ON_REPAIR = 'ON_REPAIR',
}
